import React, { useState, useEffect } from 'react';

export function InstallPWAPrompt({ onClose }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Check if user has dismissed before
      const dismissed = localStorage.getItem('pwa_prompt_dismissed');
      if (!dismissed) {
        setShowPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowPrompt(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('PWA installed');
    }
    
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('pwa_prompt_dismissed', 'true');
    setShowPrompt(false);
    if (onClose) onClose();
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-fade-in">
      <div className="glass-card rounded-xl p-4 border border-primary/30 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 bg-primary/20 rounded-xl flex items-center justify-center flex-shrink-0">
            <span className="text-2xl">📱</span>
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-white mb-1">Instalar CraftFlow Pro</h3>
            <p className="text-sm text-muted-foreground mb-3">
              Instale o app no seu dispositivo para acesso rápido e funcionar offline!
            </p>
            <div className="flex gap-2">
              <button
                onClick={handleInstall}
                className="btn-primary px-4 py-2 rounded-lg text-sm font-medium"
              >
                Instalar Agora
              </button>
              <button
                onClick={handleDismiss}
                className="px-4 py-2 rounded-lg text-sm text-muted-foreground hover:text-white transition-colors"
              >
                Agora não
              </button>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-muted-foreground hover:text-white p-1"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstallPWAPrompt;
